import { WarmupControllerWarmupMethod } from '../methods/warmup-controller/warmup.method';

export class WarmupController {
  public readonly warmup = new WarmupControllerWarmupMethod();
}
